import axios from 'axios';

var catalog = null;

export default {
    GetCatalog() {
        if(catalog) {
            return Promise.resolve(catalog);
        }
        else{
            var url = process.env.PRODUCT_CATEGORY_ENDPOINT + '&OrderBy=Name&skip=0&take=200';
            return axios.get(url, { withCredentials: true }).then((response => {
                var convertedItems = response.data.map(i => {
                    return {
                        Id: i.Oid,
                        Name: i.Name,
                        FullName: i.FullName,
                        Parent: i.Parent && i.Parent.Oid,
                        Visible: !i.HideCategory,
                        ShowAllProducts: i.ShowAllProducts,
                        MinBuy: i.MinimumPurchaseQty,
                        ImageLink: i.ImageLink,
                        Items: [],
                    }
                });

                convertedItems.filter(i => i.Parent != null).forEach(i => convertedItems.find(c => c.Id == i.Parent).Items.push(i));
                catalog = convertedItems.filter(i => i.Parent == null);

                catalog.forEach(c => {
                    c.VisibleItems = c.Items.filter(i => i.Visible);
                    c.Items.forEach(i => i.ParentCategory = c);
                });


                return catalog;
            }));
        }
    },
    async GetCategoryByFullName(name) {
        if(!catalog) {
            await this.GetCatalog();
        }

        var fulList = catalog.concat(catalog.flatMap(c => c.Items));

        return fulList.find(c => c.FullName == name);
    }
}


// WEBPACK FOOTER //
// ./src/services/ConfigService.js